import { getOtherFreebetRewardsQuery } from '@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/graphql/OtherFreebetRewardsQuery.generated';

type Args = {
  inGameCurrency?: Unit;
  walletCurrency: Unit;
  gameId?: string;
  isGameCurrencyChangeEnabled?: boolean;
};

const getFreebetReward = async ({
  inGameCurrency,
  walletCurrency,
  gameId,
  isGameCurrencyChangeEnabled,
}: Args) => {
  const { data } = await getOtherFreebetRewardsQuery({
    currency: walletCurrency,
    game: gameId ?? '',
    inGameCurrency: isGameCurrencyChangeEnabled ? inGameCurrency : undefined,
  });

  const reward = data?.rewards?.myOtherFreebetRewards?.edges?.[0]?.node;
  return { reward };
};

export default getFreebetReward;
